import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Link from 'theme/atoms/Link'

type Props = {
  link: string
  src: string
  alt: string
  title: any
  description: any
}

export default function SidebarImage(props: Props) {
  return (
    <Wrapper className="SidebarImage" to={props.link}>
      <img src={props.src} alt={props.alt} width={90} height={68} />
      <div className="info">
        <div className="title">{props.title}</div>
        <div className="desc">{props.description}</div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled(Link)`
  display: flex;
  > .info {
    flex: 1;
    margin-left: ${theme.spacing('m')};
    > .title {
      ${theme.ty('rc-l', 'bold')}
      margin-bottom: ${theme.spacing('xxs')};
    }
    > .desc {
      ${theme.ty('rc-base')}
    }
  }
`
